import Http from '_u/request'
import { Toast } from 'vant'
import { crmApiConfig } from '@/config'

const http = new Http()
const queue = {}

const Request = async ({ data = {}, ...config }) => {
  config.headers = Object.assign(config.headers || {}, crmApiConfig)
  const { apiLoading, apiReject, _config = {}, ...parameters } = data
  // 请求等待
  if (apiLoading) {
    queue[config.url] = Toast({
      message: typeof apiLoading === 'string' ? apiLoading : '加载中...',
      forbidClick: true,
      duration: 0,
      className: 'animate-rotate',
      icon: require('img/crm/icon/loading.png')
    })
  }
  let res = null
  try {
    res = await http.request({ ...config, ..._config, parameters })
  } catch (err) {
    res = err
  } finally {
    // 请求等待结束
    if (queue[config.url]) {
      queue[config.url].clear()
      delete queue[config.url]
    }
  }
  // 请求错误反馈
  if ((!apiReject || (typeof apiReject === 'number' && res.code !== apiReject)) && res.code !== 0) {
    Toast({
      message: res.message || res.msg,
      forbidClick: true,
      icon: require('img/crm/icon/close.png')
    })
  }
  if (res.code === 0) console.log(`${config.title}成功`, res)
  else console.error(`${config.title}失败`, res, parameters)
  return res
}

export default Request
